import React from "react";

type Props = {
	style?: React.CSSProperties;
};
const BigStarIcon = ({ style }: Props) => {
	return (
		<span className="comment__icon" style={style}>
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.0252 8.05004C15.0739 5.35001 15.5983 4 16.5 4C17.4017 4 17.9261 5.35001 18.9748 8.05004L19.0236 8.17577C19.6161 9.70115 19.9124 10.4638 20.5161 10.9274C21.1199 11.391 21.9124 11.4643 23.4976 11.6109L23.7841 11.6374C26.3784 11.8773 27.6755 11.9973 27.953 12.8496C28.2306 13.7018 27.2673 14.6069 25.3407 16.417L24.6977 17.0212C23.7224 17.9375 23.2348 18.3957 23.0075 18.9961C22.9651 19.1082 22.9299 19.2229 22.902 19.3397C22.7526 19.9657 22.8954 20.6304 23.181 21.9597L23.2699 22.3735C23.7947 24.8165 24.0572 26.038 23.599 26.5649C23.4277 26.7617 23.2052 26.9035 22.958 26.9732C22.2965 27.1596 21.3572 26.3692 19.4787 24.7884C18.2453 23.7504 17.6285 23.2314 16.9204 23.1147C16.6419 23.0688 16.3581 23.0688 16.0796 23.1147C15.3715 23.2314 14.7547 23.7504 13.5213 24.7884C11.6428 26.3692 10.7035 27.1596 10.042 26.9732C9.79478 26.9035 9.57225 26.7617 9.40103 26.5649C8.94282 26.038 9.20525 24.8165 9.73012 22.3735L9.81901 21.9597C10.1046 20.6304 10.2474 19.9657 10.098 19.3397C10.0701 19.2229 10.0349 19.1082 9.99249 18.9961C9.76521 18.3957 9.27757 17.9375 8.3023 17.0212L7.6593 16.417C5.7327 14.6069 4.76941 13.7018 5.04696 12.8496C5.32451 11.9973 6.62163 11.8773 9.21588 11.6374L9.50244 11.6109C11.0876 11.4643 11.8801 11.391 12.4839 10.9274C13.0876 10.4638 13.3839 9.70115 13.9764 8.17577L14.0252 8.05004Z"
					fill="#3A393A"
					stroke="#3A393A"
				/>
			</svg>
		</span>
	);
};

export default BigStarIcon;
